/**
 * Mobile buy bar: shown whenever the real COD button isn't on screen —
 * before the shopper reaches it as well as after scrolling past — so price,
 * CTA and "pay on delivery" are always one glance away. Hidden only while the
 * real button itself is visible, to avoid two identical CTAs at once. Plain
 * show/hide, no transition (see the note on fast scrolls below).
 */
(function () {
  function syncPrice(sticky) {
    // The checked pack radio of blocks/zc-bundles.liquid carries the pack's
    // price, struck-through price and a short label ("120 cápsulas").
    var active = document.querySelector('[data-zc-bundles] .zc-bundle__input:checked');
    if (!active) return;

    var priceEl = sticky.querySelector('[data-zc-sticky-price]');
    var compareEl = sticky.querySelector('[data-zc-sticky-compare]');
    var qtyEl = sticky.querySelector('[data-zc-sticky-qty]');
    var hasSaving = parseInt(active.dataset.pct || '0', 10) > 0;

    if (priceEl && active.dataset.price) priceEl.textContent = active.dataset.price;
    if (compareEl) {
      compareEl.textContent = hasSaving ? active.dataset.compare : '';
      compareEl.hidden = !hasSaving;
    }
    if (qtyEl && active.dataset.label) qtyEl.textContent = active.dataset.label;
  }

  function initStickySources() {
    document.querySelectorAll('[data-zc-cod-sticky-source]').forEach(function (source) {
      if (source.dataset.stickyBound) return;
      source.dataset.stickyBound = 'true';

      var sticky = document.getElementById(source.dataset.zcCodStickySource);
      if (!sticky) return;
      syncPrice(sticky);

      var observer = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          if (!entry) return;
          // Recomputed from scratch on every callback rather than toggled:
          // a fast scroll or an instant jump can skip clean past the moment
          // the button crosses the viewport edge, and a toggle would then
          // leave the bar stuck in the wrong state.
          var show = !entry.isIntersecting;
          if (show) syncPrice(sticky);
          sticky.hidden = !show;

          // The bar's height (--zc-cod-sticky-h) is published by the
          // ResizeObserver below: reading offsetHeight right here, just
          // after un-hiding it, forced a layout of the whole page.

          // The WhatsApp bubble (.zc-wa) shares this bottom corner — lifted
          // above the bar by CSS while this class is on.
          document.documentElement.classList.toggle('zc-cod-sticky-on', show);
        },
        { threshold: 0 },
      );
      observer.observe(source);

      // Exposed for anything floating in the same bottom strip (the
      // WhatsApp bubble, cookie banner) so it can sit above the bar.
      if (typeof ResizeObserver === 'function') {
        new ResizeObserver(function (entries) {
          var box = entries[0].borderBoxSize && entries[0].borderBoxSize[0];
          var height = box ? box.blockSize : entries[0].target.offsetHeight;
          if (height > 0) document.documentElement.style.setProperty('--zc-cod-sticky-h', height + 'px');
        }).observe(sticky);
      } else if (!sticky.hidden) {
        document.documentElement.style.setProperty('--zc-cod-sticky-h', sticky.offsetHeight + 'px');
      }

      document.addEventListener('zc:bundle-updated', function () {
        syncPrice(sticky);
      });
    });
  }

  /**
   * The bar never opens the drawer directly: clicking scrolls to the offer
   * tiers (same page, no URL change) so the shopper picks one; the real
   * button, now in view, is what opens the checkout drawer.
   */
  function initScrollToOffers() {
    document.querySelectorAll('[data-zc-cod-scroll-to-offers]').forEach(function (button) {
      if (button.dataset.scrollBound) return;
      button.dataset.scrollBound = 'true';
      button.addEventListener('click', function () {
        var offers = document.querySelector('[data-zc-bundles]');
        if (offers) offers.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initStickySources();
      initScrollToOffers();
    });
  } else {
    initStickySources();
    initScrollToOffers();
  }
  document.addEventListener('shopify:section:load', function () {
    initStickySources();
    initScrollToOffers();
  });
})();
